export default __webpack_public_path__ + "static/media/footer-logo.8a810a8a.svg";